export default class ProductTypeManagementColumnModel {
	static ProductTypeManagementColumn = [
	  {
		  title: 'Product type',
		  align: 'left',
		  field: 'productTypeName'
	  }
	]
}
